export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14045.eac52381.jpg";